import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ unread: 0, pending_queue: 0, refresh: () => {} });

export function BadgeProvider({ children }) {
  const [b, setB] = useState({ unread: 0, pending_queue: 0 });
  const refresh = useCallback(() => api.get("/badges").then((r) => setB(r.data)).catch(() => {}), []);
  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [refresh]);
  return <Ctx.Provider value={{ ...b, refresh }}>{children}</Ctx.Provider>;
}

export const useBadges = () => useContext(Ctx);
